__turbopack_context__.v({
  "video-callout": "VideoCallout-module-scss-module__OAF0xa__video-callout",
  "video-callout__body": "VideoCallout-module-scss-module__OAF0xa__video-callout__body",
  "video-callout__content": "VideoCallout-module-scss-module__OAF0xa__video-callout__content",
  "video-callout__cta": "VideoCallout-module-scss-module__OAF0xa__video-callout__cta",
  "video-callout__grid": "VideoCallout-module-scss-module__OAF0xa__video-callout__grid",
  "video-callout__media": "VideoCallout-module-scss-module__OAF0xa__video-callout__media",
  "video-callout__play": "VideoCallout-module-scss-module__OAF0xa__video-callout__play",
  "video-callout__poster": "VideoCallout-module-scss-module__OAF0xa__video-callout__poster",
  "video-callout__poster-fallback": "VideoCallout-module-scss-module__OAF0xa__video-callout__poster-fallback",
  "video-callout__text": "VideoCallout-module-scss-module__OAF0xa__video-callout__text",
  "video-callout__title": "VideoCallout-module-scss-module__OAF0xa__video-callout__title",
});
